import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useRef } from 'react';

import { Message } from '../types';

import MessageBubble from './MessageBubble';

interface MessageListProps {
  messages: Message[];
}

const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView();
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className='flex-1 flex items-center justify-center bg-gray-50'>
        <div className='text-center text-gray-500'>
          <div className='flex justify-center mb-4'>
            <ChatBubbleLeftIcon className='w-16 h-16' />
          </div>
          <h3 className='text-lg font-medium mb-2'>No messages yet</h3>
          <p className='text-sm'>
            Start a conversation by typing a message below.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='flex-1 overflow-y-auto bg-gray-50 px-4 py-6 min-h-0'>
      <div className='max-w-4xl mx-auto'>
        {messages.map((message: Message) => (
          <MessageBubble key={message.id} message={message} />
        ))}
        {/* Scroll anchor */}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default MessageList;
